<form [formGroup]="addressDetails">
    <div>
        @if (showFormLabel) {
        <h3>{{ formLabel }}</h3>
        }
        <div class="flex-container">
            <div class="validated-form-field-container flex-container margin-sides-5">
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>{{ labels.streetNumber }}</mat-label>
                    <input matInput [libAutoCapitalize]="uiConfiguration?.autoCapitalizeFields ?? false" data-testid="street-number-field" [formControlName]="'streetNumber'" />
                </mat-form-field>
                <lib-error-bubble [control]="addressDetails.controls['streetNumber']"
                    [message]="streetNumberError$"></lib-error-bubble>
            </div>

            <div class="validated-form-field-container flex-container">
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>{{ labels.streetName }}</mat-label>
                    <input matInput [libAutoCapitalize]="uiConfiguration?.autoCapitalizeFields ?? false" data-testid="street-name-field" [formControlName]="'streetName'" />
                </mat-form-field>
                <lib-error-bubble [control]="addressDetails.controls['streetName']"
                    [message]="streetNameError$"></lib-error-bubble>
            </div>
        </div>

        <div class="flex-container">
            <div class="validated-form-field-container flex-container">
                <mat-form-field appearance="outline" class="form-field flex-item">
                    <mat-label>{{ labels.unit }}</mat-label>
                    <input matInput [libAutoCapitalize]="uiConfiguration?.autoCapitalizeFields ?? false" data-testid="street-unit-field" [formControlName]="'unit'" />
                </mat-form-field>
                <lib-error-bubble [control]="addressDetails.controls['unit']" [message]="unitError$"></lib-error-bubble>
            </div>

            @if(uiConfiguration?.showQuadrant) {
            <div class="validated-form-field-container flex-container">
                <mat-form-field appearance="outline" class="form-field flex-item">
                    <mat-label>{{ labels.quadrant }}</mat-label>
                    <mat-select formControlName="quadrant" data-testid="address-quadrant-dropdown">
                        @for (opt of quadrants; track opt) {
                        <mat-option [value]="opt" data-testid="quadrant" [attr.data-testid]="'address-quadrant-option-' + opt"> {{ opt }} </mat-option>
                        }
                    </mat-select>
                    @if (addressDetails.get('quadrant')?.value) {
                    <mat-icon matPrefix role="button" tabindex="0" aria-hidden="false" (click)="clearQuadrant(); $event.stopPropagation();"
                    (keydown.enter)="clearQuadrant(); $event.stopPropagation();"
                    (keydown.space)="clearQuadrant(); $event.stopPropagation(); $event.preventDefault();" color="accent" [attr.aria-label]="'addressForm.clearQuadrant' | transloco" data-testid="clear-quadrant-button">
                        cancel
                    </mat-icon>
                    }
                </mat-form-field>
                <lib-error-bubble [message]="quadrantError$"></lib-error-bubble>
            </div>
            }

            <div class="validated-form-field-container flex-container">
                <mat-form-field appearance="outline" class="form-field flex-item">
                    <mat-label>{{ labels.city }}</mat-label>
                    <input matInput [libAutoCapitalize]="uiConfiguration?.autoCapitalizeFields ?? false" data-testid="city-field" [formControlName]="'city'" />
                </mat-form-field>
                <lib-error-bubble [control]="addressDetails.controls['city']" [message]="cityError$"></lib-error-bubble>
            </div>

            <div class="validated-form-field-container flex-container">
                <mat-form-field appearance="outline" class="form-field flex-item">
                    <mat-label>{{ labels.postalCode }}</mat-label>
                    <input matInput [libAutoCapitalize]="(uiConfiguration?.autoCapitalizeFields ?? false) || (uiConfiguration?.autoCapitalizePostalCode ?? false)" data-testid="postal-code-field" [formControlName]="'postalCode'" />
                </mat-form-field>
                <lib-error-bubble [control]="addressDetails.controls['postalCode']"
                    [message]="postalCodeError$"></lib-error-bubble>
            </div>
        </div>

        <lib-jurisdiction-selection [staticCountryCode]="staticCountryCode" [staticJurisdiction]="staticJurisdiction"
            [allowInternationalAddressJurisdiction]="uiConfiguration?.allowInternationalAddressJurisdiction ?? false"
            [appearance]="'outline'" [countryFieldName]="labels.country" [jurisdictionFieldName]="labels.jurisdiction"
            [defaultCountry]="'CA'" [address]="address" [autoCapitalizeFields]="uiConfiguration?.autoCapitalizeFields ?? false"
            [labels]="{ search: labels.search, noMatchesFound: labels.noMatchesFound }"
            [labelTranslator]="labelTranslator" [langChange$]="langChange$">
        </lib-jurisdiction-selection>
    </div>
</form>